import {
  query,
  stagger,
  trigger,
  transition,
  animateChild,
  AnimationTriggerMetadata,
} from '@angular/animations';

export const snStagger: AnimationTriggerMetadata = trigger('snStagger', [
  transition('void => 50', query('@*', [stagger('50ms', [animateChild()])])),
  transition('void => 100', query('@*', [stagger('100ms', [animateChild()])])),
  transition('void => 200', query('@*', [stagger('200ms', [animateChild()])])),
]);

// FIXME: when using this animation on tables, causes table not to load initially on route change
export const snListStagger: AnimationTriggerMetadata = trigger('snListStagger', [
  transition(':enter, * => *', [
    query(':enter', [stagger(25, [animateChild()])], { optional: true }),
    query(':leave', [stagger(5, [animateChild()])], { optional: true }),
  ]),
]);
